/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ImportJobSource;
(function (ImportJobSource) {
    ImportJobSource["FARSEER_FILE"] = "FARSEER_FILE";
    ImportJobSource["EXTERNAL_DATA"] = "EXTERNAL_DATA";
})(ImportJobSource || (ImportJobSource = {}));
export function ImportJobSourceFromJSON(json) {
    return ImportJobSourceFromJSONTyped(json, false);
}
export function ImportJobSourceFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ImportJobSourceToJSON(value) {
    return value;
}
